<template>
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="操作日期">
        <div class="block">
          <span class="demonstration"></span>
          <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="已通过" value="1"></el-option>
          <el-option label="未通过" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票状态">
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="已通过" value="1"></el-option>
          <el-option label="未通过" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" >查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" >申请开票</el-button>
      </el-form-item>
    </el-form>

    <div class="">
      <div class="">

      </div>


      <el-table size="small" :data="tableData.data" border class="table" style="width: 100%" v-loading="loading"
        @selection-change="handleSelectionChange" default-expand-all ref="table" row-key="order_id">
        <el-table-column type="selection" width="40" style="min-width: 100px"/>
        <el-table-column prop="user_id" label="日期" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="账单类型" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="账单量" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="应开票金额" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="操作时间" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="备注" width="230">

        </el-table-column>
        <el-table-column prop="user_id" label="操作!" width="230">
          <template slot-scope="scope">


          </template>
        </el-table-column>

      </el-table>
    </div>






  </div>
</template>

<script>
  export default{
    data(){
      return {

      }
    },
    mounted() {

    },
    methods:{
      // 多选选中
      handleSelectionChange(val) {
        console.log(val);
      },


    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/invoice.vue